/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/

import React from 'react';

const FluidBackground: React.FC = () => {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden bg-[#0f172a]">
      {/* Static gradient blobs - no animation for better performance */}
      <div className="absolute top-[-20%] left-[-10%] w-[100vw] h-[100vw] bg-[#1e3a8a] rounded-full opacity-20" 
           style={{ filter: 'blur(80px)' }} />
      
      <div className="absolute top-[30%] right-[-20%] w-[80vw] h-[80vw] bg-[#f97316] rounded-full opacity-10" 
           style={{ filter: 'blur(100px)' }} />
      
      <div className="absolute bottom-[-30%] left-[10%] w-[90vw] h-[90vw] bg-[#475569] rounded-full opacity-20" 
           style={{ filter: 'blur(60px)' }} />
      
      {/* Vignette */}
      <div className="absolute inset-0 pointer-events-none" 
           style={{ background: 'radial-gradient(circle at center, transparent 0%, rgba(15, 23, 42, 0.5) 50%, rgb(15, 23, 42) 100%)' }} />
    </div>
  );
};

export default FluidBackground;